import React from 'react'
import authRoute from './authRoute'

export const publicRoutes = [...authRoute]

export const protectedRoutes = [
    {
        key: 'dashboard',
        path: '/dashboard',
        component: React.lazy(() => import('views/Dashboard')),
        authority: [],
    },
    {
        key: 'openAuctions',
        path: '/auction-list',
        component: React.lazy(() => import('views/auction/AuctionList')),
        authority: [],
    },
    {
        key: 'myActiveBids',
        path: '/my-active-bids',
        component: React.lazy(() => import('views/auction/MyActiveBids')),
        authority: [],
    },
    {
        key: 'auctionsHistory',
        path: '/auctions-history',
        component: React.lazy(() => import('views/auction/AuctionHistory')),
        authority: [],
    },
    {
        key: 'auctionDetial',
        path: '/auction-detail/:id',
        component: React.lazy(() => import('views/auction/AuctionDetail')),
        authority: [],
    },
    {
        key: 'billingOverview',
        path: '/billing-overview',
        component: React.lazy(() => import('views/billing/Overview')),
        authority: [],
    },
    {
        key: 'paymentMethods',
        path: '/payment-methods',
        component: React.lazy(() => import('views/billing/PaymentMethods')),
        authority: [],
    },
    {
        key: 'payments',
        path: '/payments',
        component: React.lazy(() => import('views/billing/Payments')),
        authority: [],
    },
    // {
    //     key: 'closedInvoices',
    //     path: '/closed-invoices',
    //     component: React.lazy(() => import('views/invoices/closedInvoice')),
    //     authority: [],
    // },
    // {
    //     key: 'outstandingInvoices',
    //     path: '/outstanding-invoices',
    //     component: React.lazy(() => import('views/invoices/outstandingInvoice')),
    //     authority: [],
    // },
    {
        key: 'statementOfAccount',
        path: '/statement-of-account',
        component: React.lazy(() => import('views/billing/StatementOfAccount')),
        authority: [],
    },
    {
        key: 'profile',
        path: '/profile',
        component: React.lazy(() => import('views/account/Profile')),
        authority: [],
    },
    {
        key: 'changePassword',
        path: '/change-password',
        component: React.lazy(() => import('views/auth/ResetPassword')),
        authority: [],
    },
    {
        key: 'helpAndSupport',
        path: '/help-and-support',
        component: React.lazy(() => import('views/HelpAndSupport')),
        authority: [],
    },
    {
        key: 'termAndConditions',
        path: '/terms-and-conditions',
        component: React.lazy(() => import('views/termAndConditions')),
        authority: [],
    },
    {
        key: 'contactUs',
        path: '/contact-us',
        component: React.lazy(() => import('views/contactUs')),
        authority: [],
    },
    {
        key: 'aboutUs',
        path: '/about-us',
        component: React.lazy(() => import('views/aboutUs')),
        authority: [],
    },
    {
        key: 'siteMap',
        path: '/site-map',
        component: React.lazy(() => import('views/siteMap')),
        authority: [],
    },
]
